{
  "schemaVersion": 1,
  "map": {
    "width": 960,
    "height": 14400,
    "coordinateOrigin": "top-left",
    "locationHeight": 960,
    "displayDirection": "top-to-bottom"
  },
  "worlds": [
    {
      "id": 1,
      "name": "Tokyo Pop",
      "slug": "tokyo-pop",
      "boardSize": 5,
      "background": "map/backgrounds/world-01-tokyo-pop.png",
      "y": 0,
      "height": 2880,
      "locationIds": [
        1,
        2,
        3
      ]
    },
    {
      "id": 2,
      "name": "Seoul Wave",
      "slug": "seoul-wave",
      "boardSize": 6,
      "background": "map/backgrounds/world-02-seoul-wave.png",
      "y": 2880,
      "height": 2880,
      "locationIds": [
        4,
        5,
        6
      ]
    },
    {
      "id": 3,
      "name": "Night Bites",
      "slug": "night-bites",
      "boardSize": 7,
      "background": "map/backgrounds/world-03-night-bites.png",
      "y": 5760,
      "height": 2880,
      "locationIds": [
        7,
        8,
        9
      ]
    },
    {
      "id": 4,
      "name": "Eastern Chill",
      "slug": "eastern-chill",
      "boardSize": 8,
      "background": "map/backgrounds/world-04-eastern-chill.png",
      "y": 8640,
      "height": 2880,
      "locationIds": [
        10,
        11,
        12
      ]
    },
    {
      "id": 5,
      "name": "Future East",
      "slug": "future-east",
      "boardSize": 9,
      "background": "map/backgrounds/world-05-future-east.png",
      "y": 11520,
      "height": 2880,
      "locationIds": [
        13,
        14,
        15
      ]
    }
  ],
  "locations": [
    {
      "id": 1,
      "worldId": 1,
      "indexInWorld": 1,
      "name": "Harajuku Sticker Street",
      "characterName": "Sticker Shiba",
      "characterId": "sticker-shiba",
      "characterAsset": "characters/01-sticker-shiba.png",
      "personalityHu": "Matricák, kis utcák, nagy ötletek.",
      "levelStart": 1,
      "levelEnd": 9,
      "unlockAfterLevel": 9,
      "boardSize": 5,
      "y": 0,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 798,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 2,
      "worldId": 1,
      "indexInWorld": 2,
      "name": "Shibuya Neon Crossing",
      "characterName": "Neon Shiba",
      "characterId": "neon-shiba",
      "characterAsset": "characters/02-neon-shiba.png",
      "personalityHu": "A város fényeit követi.",
      "levelStart": 10,
      "levelEnd": 18,
      "unlockAfterLevel": 18,
      "boardSize": 5,
      "y": 960,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 1758,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 3,
      "worldId": 1,
      "indexInWorld": 3,
      "name": "Akihabara Capsule Arcade",
      "characterName": "Gacha Shiba",
      "characterId": "gacha-shiba",
      "characterAsset": "characters/03-gacha-shiba.png",
      "personalityHu": "Minden sarok új felfedezés.",
      "levelStart": 19,
      "levelEnd": 27,
      "unlockAfterLevel": 27,
      "boardSize": 5,
      "y": 1920,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 2718,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 4,
      "worldId": 2,
      "indexInWorld": 1,
      "name": "K-Pop Practice Room",
      "characterName": "Idol Shiba",
      "characterId": "idol-shiba",
      "characterAsset": "characters/04-idol-shiba.png",
      "personalityHu": "A saját ritmusában gondolkodik.",
      "levelStart": 28,
      "levelEnd": 36,
      "unlockAfterLevel": 36,
      "boardSize": 6,
      "y": 2880,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 3678,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 5,
      "worldId": 2,
      "indexInWorld": 2,
      "name": "Hongdae Rooftop Skatepark",
      "characterName": "Skater Shiba",
      "characterId": "skater-shiba",
      "characterAsset": "characters/05-skater-shiba.png",
      "personalityHu": "Minden kanyarban talál egy ötletet.",
      "levelStart": 37,
      "levelEnd": 45,
      "unlockAfterLevel": 45,
      "boardSize": 6,
      "y": 3840,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 4638,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 6,
      "worldId": 2,
      "indexInWorld": 3,
      "name": "Seongsu Pop-Up Lab",
      "characterName": "Acubi Shiba",
      "characterId": "acubi-shiba",
      "characterAsset": "characters/06-acubi-shiba.png",
      "personalityHu": "Letisztult stílus, rafinált gondolatok.",
      "levelStart": 46,
      "levelEnd": 54,
      "unlockAfterLevel": 54,
      "boardSize": 6,
      "y": 4800,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 5598,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 7,
      "worldId": 3,
      "indexInWorld": 1,
      "name": "Taipei Bubble Tea Lab",
      "characterName": "Boba Shiba",
      "characterId": "boba-shiba",
      "characterAsset": "characters/07-boba-shiba.png",
      "personalityHu": "Egy korty nyugalom két feladvány között.",
      "levelStart": 55,
      "levelEnd": 63,
      "unlockAfterLevel": 63,
      "boardSize": 7,
      "y": 5760,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 6558,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 8,
      "worldId": 3,
      "indexInWorld": 2,
      "name": "Robot Ramen Bar",
      "characterName": "Ramen Shiba",
      "characterId": "ramen-shiba",
      "characterAsset": "characters/08-ramen-shiba.png",
      "personalityHu": "Mindig kifőz valami okosat.",
      "levelStart": 64,
      "levelEnd": 72,
      "unlockAfterLevel": 72,
      "boardSize": 7,
      "y": 6720,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 7518,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 9,
      "worldId": 3,
      "indexInWorld": 3,
      "name": "Hong Kong Night Market",
      "characterName": "Foodie Shiba",
      "characterId": "foodie-shiba",
      "characterAsset": "characters/09-foodie-shiba.png",
      "personalityHu": "Kíváncsisága minden utcába elvezeti.",
      "levelStart": 73,
      "levelEnd": 81,
      "unlockAfterLevel": 81,
      "boardSize": 7,
      "y": 7680,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 8478,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 10,
      "worldId": 4,
      "indexInWorld": 1,
      "name": "Sakura Riverwalk",
      "characterName": "Sakura Shiba",
      "characterId": "sakura-shiba",
      "characterAsset": "characters/10-sakura-shiba.png",
      "personalityHu": "A csendben is észreveszi a lehetőséget.",
      "levelStart": 82,
      "levelEnd": 90,
      "unlockAfterLevel": 90,
      "boardSize": 8,
      "y": 8640,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 9438,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 11,
      "worldId": 4,
      "indexInWorld": 2,
      "name": "Kyoto Moonlight Alley",
      "characterName": "Lantern Shiba",
      "characterId": "lantern-shiba",
      "characterAsset": "characters/11-lantern-shiba.png",
      "personalityHu": "Egy kis fény is utat mutathat.",
      "levelStart": 91,
      "levelEnd": 99,
      "unlockAfterLevel": 99,
      "boardSize": 8,
      "y": 9600,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 10398,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 12,
      "worldId": 4,
      "indexInWorld": 3,
      "name": "Bamboo Lo-Fi Garden",
      "characterName": "Lo-Fi Shiba",
      "characterId": "lofi-shiba",
      "characterAsset": "characters/12-lofi-shiba.png",
      "personalityHu": "A nyugalom az ő szuperereje.",
      "levelStart": 100,
      "levelEnd": 108,
      "unlockAfterLevel": 108,
      "boardSize": 8,
      "y": 10560,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 11358,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 13,
      "worldId": 5,
      "indexInWorld": 1,
      "name": "Shanghai Cyber Garden",
      "characterName": "Cyber Shiba",
      "characterId": "cyber-shiba",
      "characterAsset": "characters/13-cyber-shiba.png",
      "personalityHu": "A jövőben is van helye a játékosságnak.",
      "levelStart": 109,
      "levelEnd": 117,
      "unlockAfterLevel": 117,
      "boardSize": 9,
      "y": 11520,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 12318,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 14,
      "worldId": 5,
      "indexInWorld": 2,
      "name": "Singapore Cloud Garden",
      "characterName": "Eco Shiba",
      "characterId": "eco-shiba",
      "characterAsset": "characters/14-eco-shiba.png",
      "personalityHu": "Apró lépésekkel nagy dolgokat épít.",
      "levelStart": 118,
      "levelEnd": 126,
      "unlockAfterLevel": 126,
      "boardSize": 9,
      "y": 12480,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 13278,
        "width": 224,
        "height": 224
      }
    },
    {
      "id": 15,
      "worldId": 5,
      "indexInWorld": 3,
      "name": "Neon Moon Festival",
      "characterName": "Moon Shiba",
      "characterId": "moon-shiba",
      "characterAsset": "characters/15-moon-shiba.png",
      "personalityHu": "A legmesszibb célhoz is eljut.",
      "levelStart": 127,
      "levelEnd": 135,
      "unlockAfterLevel": 135,
      "boardSize": 9,
      "y": 13440,
      "height": 960,
      "rewardAnchor": {
        "x": 155,
        "y": 14238,
        "width": 224,
        "height": 224
      }
    }
  ],
  "levels": [
    {
      "id": 1,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 1,
      "boardSize": 5,
      "x": 320,
      "y": 230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-001"
    },
    {
      "id": 2,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 2,
      "boardSize": 5,
      "x": 540,
      "y": 310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-002"
    },
    {
      "id": 3,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 3,
      "boardSize": 5,
      "x": 700,
      "y": 390,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-003"
    },
    {
      "id": 4,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 4,
      "boardSize": 5,
      "x": 570,
      "y": 470,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-004"
    },
    {
      "id": 5,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 5,
      "boardSize": 5,
      "x": 350,
      "y": 550,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-005"
    },
    {
      "id": 6,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 6,
      "boardSize": 5,
      "x": 220,
      "y": 630,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-006"
    },
    {
      "id": 7,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 7,
      "boardSize": 5,
      "x": 410,
      "y": 710,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-007"
    },
    {
      "id": 8,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 8,
      "boardSize": 5,
      "x": 680,
      "y": 790,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-008"
    },
    {
      "id": 9,
      "worldId": 1,
      "locationId": 1,
      "indexInLocation": 9,
      "boardSize": 5,
      "x": 540,
      "y": 870,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "sticker-shiba",
      "puzzleId": "campaign-009"
    },
    {
      "id": 10,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 1,
      "boardSize": 5,
      "x": 320,
      "y": 1190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-010"
    },
    {
      "id": 11,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 2,
      "boardSize": 5,
      "x": 540,
      "y": 1270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-011"
    },
    {
      "id": 12,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 3,
      "boardSize": 5,
      "x": 700,
      "y": 1350,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-012"
    },
    {
      "id": 13,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 4,
      "boardSize": 5,
      "x": 570,
      "y": 1430,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-013"
    },
    {
      "id": 14,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 5,
      "boardSize": 5,
      "x": 350,
      "y": 1510,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-014"
    },
    {
      "id": 15,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 6,
      "boardSize": 5,
      "x": 220,
      "y": 1590,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-015"
    },
    {
      "id": 16,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 7,
      "boardSize": 5,
      "x": 410,
      "y": 1670,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-016"
    },
    {
      "id": 17,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 8,
      "boardSize": 5,
      "x": 680,
      "y": 1750,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-017"
    },
    {
      "id": 18,
      "worldId": 1,
      "locationId": 2,
      "indexInLocation": 9,
      "boardSize": 5,
      "x": 540,
      "y": 1830,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "neon-shiba",
      "puzzleId": "campaign-018"
    },
    {
      "id": 19,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 1,
      "boardSize": 5,
      "x": 320,
      "y": 2150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-019"
    },
    {
      "id": 20,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 2,
      "boardSize": 5,
      "x": 540,
      "y": 2230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-020"
    },
    {
      "id": 21,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 3,
      "boardSize": 5,
      "x": 700,
      "y": 2310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-021"
    },
    {
      "id": 22,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 4,
      "boardSize": 5,
      "x": 570,
      "y": 2390,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-022"
    },
    {
      "id": 23,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 5,
      "boardSize": 5,
      "x": 350,
      "y": 2470,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-023"
    },
    {
      "id": 24,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 6,
      "boardSize": 5,
      "x": 220,
      "y": 2550,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-024"
    },
    {
      "id": 25,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 7,
      "boardSize": 5,
      "x": 410,
      "y": 2630,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-025"
    },
    {
      "id": 26,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 8,
      "boardSize": 5,
      "x": 680,
      "y": 2710,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-026"
    },
    {
      "id": 27,
      "worldId": 1,
      "locationId": 3,
      "indexInLocation": 9,
      "boardSize": 5,
      "x": 540,
      "y": 2790,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "gacha-shiba",
      "puzzleId": "campaign-027"
    },
    {
      "id": 28,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 1,
      "boardSize": 6,
      "x": 320,
      "y": 3110,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-028"
    },
    {
      "id": 29,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 2,
      "boardSize": 6,
      "x": 540,
      "y": 3190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-029"
    },
    {
      "id": 30,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 3,
      "boardSize": 6,
      "x": 700,
      "y": 3270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-030"
    },
    {
      "id": 31,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 4,
      "boardSize": 6,
      "x": 570,
      "y": 3350,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-031"
    },
    {
      "id": 32,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 5,
      "boardSize": 6,
      "x": 350,
      "y": 3430,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-032"
    },
    {
      "id": 33,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 6,
      "boardSize": 6,
      "x": 220,
      "y": 3510,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-033"
    },
    {
      "id": 34,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 7,
      "boardSize": 6,
      "x": 410,
      "y": 3590,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-034"
    },
    {
      "id": 35,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 8,
      "boardSize": 6,
      "x": 680,
      "y": 3670,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-035"
    },
    {
      "id": 36,
      "worldId": 2,
      "locationId": 4,
      "indexInLocation": 9,
      "boardSize": 6,
      "x": 540,
      "y": 3750,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "idol-shiba",
      "puzzleId": "campaign-036"
    },
    {
      "id": 37,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 1,
      "boardSize": 6,
      "x": 320,
      "y": 4070,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-037"
    },
    {
      "id": 38,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 2,
      "boardSize": 6,
      "x": 540,
      "y": 4150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-038"
    },
    {
      "id": 39,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 3,
      "boardSize": 6,
      "x": 700,
      "y": 4230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-039"
    },
    {
      "id": 40,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 4,
      "boardSize": 6,
      "x": 570,
      "y": 4310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-040"
    },
    {
      "id": 41,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 5,
      "boardSize": 6,
      "x": 350,
      "y": 4390,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-041"
    },
    {
      "id": 42,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 6,
      "boardSize": 6,
      "x": 220,
      "y": 4470,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-042"
    },
    {
      "id": 43,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 7,
      "boardSize": 6,
      "x": 410,
      "y": 4550,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-043"
    },
    {
      "id": 44,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 8,
      "boardSize": 6,
      "x": 680,
      "y": 4630,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-044"
    },
    {
      "id": 45,
      "worldId": 2,
      "locationId": 5,
      "indexInLocation": 9,
      "boardSize": 6,
      "x": 540,
      "y": 4710,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "skater-shiba",
      "puzzleId": "campaign-045"
    },
    {
      "id": 46,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 1,
      "boardSize": 6,
      "x": 320,
      "y": 5030,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-046"
    },
    {
      "id": 47,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 2,
      "boardSize": 6,
      "x": 540,
      "y": 5110,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-047"
    },
    {
      "id": 48,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 3,
      "boardSize": 6,
      "x": 700,
      "y": 5190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-048"
    },
    {
      "id": 49,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 4,
      "boardSize": 6,
      "x": 570,
      "y": 5270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-049"
    },
    {
      "id": 50,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 5,
      "boardSize": 6,
      "x": 350,
      "y": 5350,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-050"
    },
    {
      "id": 51,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 6,
      "boardSize": 6,
      "x": 220,
      "y": 5430,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-051"
    },
    {
      "id": 52,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 7,
      "boardSize": 6,
      "x": 410,
      "y": 5510,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-052"
    },
    {
      "id": 53,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 8,
      "boardSize": 6,
      "x": 680,
      "y": 5590,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-053"
    },
    {
      "id": 54,
      "worldId": 2,
      "locationId": 6,
      "indexInLocation": 9,
      "boardSize": 6,
      "x": 540,
      "y": 5670,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "acubi-shiba",
      "puzzleId": "campaign-054"
    },
    {
      "id": 55,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 1,
      "boardSize": 7,
      "x": 320,
      "y": 5990,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-055"
    },
    {
      "id": 56,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 2,
      "boardSize": 7,
      "x": 540,
      "y": 6070,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-056"
    },
    {
      "id": 57,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 3,
      "boardSize": 7,
      "x": 700,
      "y": 6150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-057"
    },
    {
      "id": 58,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 4,
      "boardSize": 7,
      "x": 570,
      "y": 6230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-058"
    },
    {
      "id": 59,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 5,
      "boardSize": 7,
      "x": 350,
      "y": 6310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-059"
    },
    {
      "id": 60,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 6,
      "boardSize": 7,
      "x": 220,
      "y": 6390,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-060"
    },
    {
      "id": 61,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 7,
      "boardSize": 7,
      "x": 410,
      "y": 6470,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-061"
    },
    {
      "id": 62,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 8,
      "boardSize": 7,
      "x": 680,
      "y": 6550,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-062"
    },
    {
      "id": 63,
      "worldId": 3,
      "locationId": 7,
      "indexInLocation": 9,
      "boardSize": 7,
      "x": 540,
      "y": 6630,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "boba-shiba",
      "puzzleId": "campaign-063"
    },
    {
      "id": 64,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 1,
      "boardSize": 7,
      "x": 320,
      "y": 6950,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-064"
    },
    {
      "id": 65,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 2,
      "boardSize": 7,
      "x": 540,
      "y": 7030,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-065"
    },
    {
      "id": 66,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 3,
      "boardSize": 7,
      "x": 700,
      "y": 7110,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-066"
    },
    {
      "id": 67,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 4,
      "boardSize": 7,
      "x": 570,
      "y": 7190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-067"
    },
    {
      "id": 68,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 5,
      "boardSize": 7,
      "x": 350,
      "y": 7270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-068"
    },
    {
      "id": 69,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 6,
      "boardSize": 7,
      "x": 220,
      "y": 7350,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-069"
    },
    {
      "id": 70,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 7,
      "boardSize": 7,
      "x": 410,
      "y": 7430,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-070"
    },
    {
      "id": 71,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 8,
      "boardSize": 7,
      "x": 680,
      "y": 7510,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-071"
    },
    {
      "id": 72,
      "worldId": 3,
      "locationId": 8,
      "indexInLocation": 9,
      "boardSize": 7,
      "x": 540,
      "y": 7590,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "ramen-shiba",
      "puzzleId": "campaign-072"
    },
    {
      "id": 73,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 1,
      "boardSize": 7,
      "x": 320,
      "y": 7910,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-073"
    },
    {
      "id": 74,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 2,
      "boardSize": 7,
      "x": 540,
      "y": 7990,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-074"
    },
    {
      "id": 75,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 3,
      "boardSize": 7,
      "x": 700,
      "y": 8070,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-075"
    },
    {
      "id": 76,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 4,
      "boardSize": 7,
      "x": 570,
      "y": 8150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-076"
    },
    {
      "id": 77,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 5,
      "boardSize": 7,
      "x": 350,
      "y": 8230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-077"
    },
    {
      "id": 78,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 6,
      "boardSize": 7,
      "x": 220,
      "y": 8310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-078"
    },
    {
      "id": 79,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 7,
      "boardSize": 7,
      "x": 410,
      "y": 8390,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-079"
    },
    {
      "id": 80,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 8,
      "boardSize": 7,
      "x": 680,
      "y": 8470,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-080"
    },
    {
      "id": 81,
      "worldId": 3,
      "locationId": 9,
      "indexInLocation": 9,
      "boardSize": 7,
      "x": 540,
      "y": 8550,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "foodie-shiba",
      "puzzleId": "campaign-081"
    },
    {
      "id": 82,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 1,
      "boardSize": 8,
      "x": 320,
      "y": 8870,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-082"
    },
    {
      "id": 83,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 2,
      "boardSize": 8,
      "x": 540,
      "y": 8950,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-083"
    },
    {
      "id": 84,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 3,
      "boardSize": 8,
      "x": 700,
      "y": 9030,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-084"
    },
    {
      "id": 85,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 4,
      "boardSize": 8,
      "x": 570,
      "y": 9110,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-085"
    },
    {
      "id": 86,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 5,
      "boardSize": 8,
      "x": 350,
      "y": 9190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-086"
    },
    {
      "id": 87,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 6,
      "boardSize": 8,
      "x": 220,
      "y": 9270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-087"
    },
    {
      "id": 88,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 7,
      "boardSize": 8,
      "x": 410,
      "y": 9350,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-088"
    },
    {
      "id": 89,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 8,
      "boardSize": 8,
      "x": 680,
      "y": 9430,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-089"
    },
    {
      "id": 90,
      "worldId": 4,
      "locationId": 10,
      "indexInLocation": 9,
      "boardSize": 8,
      "x": 540,
      "y": 9510,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "sakura-shiba",
      "puzzleId": "campaign-090"
    },
    {
      "id": 91,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 1,
      "boardSize": 8,
      "x": 320,
      "y": 9830,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-091"
    },
    {
      "id": 92,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 2,
      "boardSize": 8,
      "x": 540,
      "y": 9910,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-092"
    },
    {
      "id": 93,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 3,
      "boardSize": 8,
      "x": 700,
      "y": 9990,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-093"
    },
    {
      "id": 94,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 4,
      "boardSize": 8,
      "x": 570,
      "y": 10070,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-094"
    },
    {
      "id": 95,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 5,
      "boardSize": 8,
      "x": 350,
      "y": 10150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-095"
    },
    {
      "id": 96,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 6,
      "boardSize": 8,
      "x": 220,
      "y": 10230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-096"
    },
    {
      "id": 97,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 7,
      "boardSize": 8,
      "x": 410,
      "y": 10310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-097"
    },
    {
      "id": 98,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 8,
      "boardSize": 8,
      "x": 680,
      "y": 10390,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-098"
    },
    {
      "id": 99,
      "worldId": 4,
      "locationId": 11,
      "indexInLocation": 9,
      "boardSize": 8,
      "x": 540,
      "y": 10470,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "lantern-shiba",
      "puzzleId": "campaign-099"
    },
    {
      "id": 100,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 1,
      "boardSize": 8,
      "x": 320,
      "y": 10790,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-100"
    },
    {
      "id": 101,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 2,
      "boardSize": 8,
      "x": 540,
      "y": 10870,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-101"
    },
    {
      "id": 102,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 3,
      "boardSize": 8,
      "x": 700,
      "y": 10950,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-102"
    },
    {
      "id": 103,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 4,
      "boardSize": 8,
      "x": 570,
      "y": 11030,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-103"
    },
    {
      "id": 104,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 5,
      "boardSize": 8,
      "x": 350,
      "y": 11110,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-104"
    },
    {
      "id": 105,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 6,
      "boardSize": 8,
      "x": 220,
      "y": 11190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-105"
    },
    {
      "id": 106,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 7,
      "boardSize": 8,
      "x": 410,
      "y": 11270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-106"
    },
    {
      "id": 107,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 8,
      "boardSize": 8,
      "x": 680,
      "y": 11350,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-107"
    },
    {
      "id": 108,
      "worldId": 4,
      "locationId": 12,
      "indexInLocation": 9,
      "boardSize": 8,
      "x": 540,
      "y": 11430,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "lofi-shiba",
      "puzzleId": "campaign-108"
    },
    {
      "id": 109,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 1,
      "boardSize": 9,
      "x": 320,
      "y": 11750,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-109"
    },
    {
      "id": 110,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 2,
      "boardSize": 9,
      "x": 540,
      "y": 11830,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-110"
    },
    {
      "id": 111,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 3,
      "boardSize": 9,
      "x": 700,
      "y": 11910,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-111"
    },
    {
      "id": 112,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 4,
      "boardSize": 9,
      "x": 570,
      "y": 11990,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-112"
    },
    {
      "id": 113,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 5,
      "boardSize": 9,
      "x": 350,
      "y": 12070,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-113"
    },
    {
      "id": 114,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 6,
      "boardSize": 9,
      "x": 220,
      "y": 12150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-114"
    },
    {
      "id": 115,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 7,
      "boardSize": 9,
      "x": 410,
      "y": 12230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-115"
    },
    {
      "id": 116,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 8,
      "boardSize": 9,
      "x": 680,
      "y": 12310,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-116"
    },
    {
      "id": 117,
      "worldId": 5,
      "locationId": 13,
      "indexInLocation": 9,
      "boardSize": 9,
      "x": 540,
      "y": 12390,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "cyber-shiba",
      "puzzleId": "campaign-117"
    },
    {
      "id": 118,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 1,
      "boardSize": 9,
      "x": 320,
      "y": 12710,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-118"
    },
    {
      "id": 119,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 2,
      "boardSize": 9,
      "x": 540,
      "y": 12790,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-119"
    },
    {
      "id": 120,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 3,
      "boardSize": 9,
      "x": 700,
      "y": 12870,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-120"
    },
    {
      "id": 121,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 4,
      "boardSize": 9,
      "x": 570,
      "y": 12950,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-121"
    },
    {
      "id": 122,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 5,
      "boardSize": 9,
      "x": 350,
      "y": 13030,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-122"
    },
    {
      "id": 123,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 6,
      "boardSize": 9,
      "x": 220,
      "y": 13110,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-123"
    },
    {
      "id": 124,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 7,
      "boardSize": 9,
      "x": 410,
      "y": 13190,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-124"
    },
    {
      "id": 125,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 8,
      "boardSize": 9,
      "x": 680,
      "y": 13270,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-125"
    },
    {
      "id": 126,
      "worldId": 5,
      "locationId": 14,
      "indexInLocation": 9,
      "boardSize": 9,
      "x": 540,
      "y": 13350,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "eco-shiba",
      "puzzleId": "campaign-126"
    },
    {
      "id": 127,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 1,
      "boardSize": 9,
      "x": 320,
      "y": 13670,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-127"
    },
    {
      "id": 128,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 2,
      "boardSize": 9,
      "x": 540,
      "y": 13750,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-128"
    },
    {
      "id": 129,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 3,
      "boardSize": 9,
      "x": 700,
      "y": 13830,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-129"
    },
    {
      "id": 130,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 4,
      "boardSize": 9,
      "x": 570,
      "y": 13910,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-130"
    },
    {
      "id": 131,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 5,
      "boardSize": 9,
      "x": 350,
      "y": 13990,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-131"
    },
    {
      "id": 132,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 6,
      "boardSize": 9,
      "x": 220,
      "y": 14070,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-132"
    },
    {
      "id": 133,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 7,
      "boardSize": 9,
      "x": 410,
      "y": 14150,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-133"
    },
    {
      "id": 134,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 8,
      "boardSize": 9,
      "x": 680,
      "y": 14230,
      "hitRadius": 66,
      "isReward": false,
      "rewardCharacterId": null,
      "puzzleId": "campaign-134"
    },
    {
      "id": 135,
      "worldId": 5,
      "locationId": 15,
      "indexInLocation": 9,
      "boardSize": 9,
      "x": 540,
      "y": 14310,
      "hitRadius": 66,
      "isReward": true,
      "rewardCharacterId": "moon-shiba",
      "puzzleId": "campaign-135"
    }
  ],
  "inputCycle": [
    "empty",
    "excluded",
    "shiba"
  ],
  "unlockRule": "complete all nine levels of a location"
}